import { MODALS_CONTAINER_ID } from 'constants/ids';

export default function PortalContainers() {
	return <div id={MODALS_CONTAINER_ID} />;
}
PortalContainers.displayName = 'PortalContainers';
